import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    // Default to 'light' if nothing is saved
    return savedTheme || 'light';
  });

  // This effect runs whenever the theme state changes
  useEffect(() => {
    // Set our custom attribute for custom components like the Sidebar
    document.documentElement.setAttribute('data-theme', theme);
    // Set Bootstrap's attribute for all Bootstrap components
    document.documentElement.setAttribute('data-bs-theme', theme);
    // Save the user's preference in localStorage
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
